export default __webpack_public_path__ + "static/media/meslay11.61cc3cc9.jpg";